/**
 * The fonts uKnowva's Theme Manager offers (backend: datasync.theme.FONTS), as
 * CSS stacks. `google` is the Google Fonts family to load for the web fonts;
 * Lato is already loaded by index.html and the rest are system fonts.
 */
export const BRAND_FONTS: { name: string; stack: string; google?: string }[] = [
  { name: 'Lato', stack: '"Lato", system-ui, -apple-system, "Segoe UI", sans-serif' },
  { name: 'Roboto', stack: '"Roboto", system-ui, sans-serif', google: 'Roboto:wght@400;500;700' },
  { name: 'Poppins', stack: '"Poppins", system-ui, sans-serif', google: 'Poppins:wght@400;500;600;700' },
  { name: 'PT Sans', stack: '"PT Sans", system-ui, sans-serif', google: 'PT+Sans:wght@400;700' },
  { name: 'Arial', stack: 'Arial, Helvetica, sans-serif' },
  { name: 'Tahoma', stack: 'Tahoma, Geneva, sans-serif' },
  { name: 'Verdana', stack: 'Verdana, Geneva, sans-serif' },
  { name: 'Times New Roman', stack: '"Times New Roman", Times, serif' },
];

export function fontStack(name: string): string | undefined {
  return BRAND_FONTS.find((f) => f.name === name)?.stack;
}

/** Add the Google Fonts stylesheet for `name` once; a system font needs none. */
export function loadBrandFont(name: string): void {
  const family = BRAND_FONTS.find((f) => f.name === name)?.google;
  if (!family) return;
  const id = `brand-font-${family}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${family}&display=swap`;
  document.head.appendChild(link);
}
